import * as Yup from "yup";

export const CustodianName = Yup.object({
  name: Yup.string().min(1).max(30).required("custodian name is required"),
  abbreviation: Yup.string()
    .min(1)
    .max(30)
    .required("abbreviation is required"),
});